const steps = [
  {
    n: "01",
    title: "Consultation",
    desc: "We understand your business goals, challenges, and vision through in-depth discussions.",
  },
  {
    n: "02",
    title: "Planning",
    desc: "Our team creates a detailed strategy and roadmap tailored to your requirements.",
  },
  {
    n: "03",
    title: "Design & Development",
    desc: "We bring the plan to life with cutting-edge design and robust development.",
  },
  {
    n: "04",
    title: "Launch & Support",
    desc: "We deploy your project and provide ongoing support to ensure success.",
  },
];

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="relative py-20 md:py-32 px-5 sm:px-6 md:px-10 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 md:mb-16 grid grid-cols-12 gap-6">
          <div className="col-span-12 md:col-span-7 min-w-0">
            <div className="text-[11px] uppercase tracking-[0.3em] text-[#FF5A00] mb-4 md:mb-5">/ Our Process</div>
            <h2 className="font-display text-3xl sm:text-4xl md:text-6xl font-semibold leading-[1.05] tracking-tight break-words">
              How we<br />
              <span className="text-stroke">work.</span>
            </h2>
            <p className="text-zinc-400 mt-5 md:mt-6 max-w-xl text-sm sm:text-base">
              A proven, streamlined process that delivers results consistently.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4">
          {steps.map((s, i) => (
            <div
              key={s.n}
              data-testid={`process-step-${i}`}
              className={`p-8 md:p-10 border-t md:border-t-0 md:border-l border-white/10 ${i === 0 ? "md:border-l-0" : ""} hover:bg-white/[0.02] transition-colors`}
            >
              <div className="text-[#FF5A00] font-display text-3xl font-semibold mb-6">{s.n}</div>
              <h3 className="font-display text-2xl font-medium mb-3 tracking-tight">{s.title}</h3>
              <p className="text-sm text-zinc-400 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
